'use strict';

intellidealerAppEquipmentModule.config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state(
    'navigation.equipment.equipmentForRent.equipmentForRentDetails', {
      url: '/equipment-for-rent-details/{company}/{stockNumber}/{division}',
      views : {
        '@navigation.equipment' : {
          templateUrl: 'app/scripts/modules/equipment/views/equipment-for-rent-details.html',
          controller: 'EquipmentForRentDetailsController'
        }
      },
      resolve: {
        help: function () {
          return 'Equipment-_Equipment_Details.htm';
        },
        breadcrumb: ['$stateParams', '$filter',
                     function ($stateParams, $filter) {
                       return $filter('pathParam')($stateParams.stockNumber);
                     }],
        equipmentForRent: [
          'equipmentResource',
          'globalAlertService',
          '$stateParams',
          '$filter',
          function(equipmentResource, globalAlertService, $stateParams, $filter) {
            return equipmentResource.dealershipRentalEquipmentDetails.get(
              {
                company: $stateParams.company,
                stockNumber: $filter('pathParam')($stateParams.stockNumber),
                division: $stateParams.division,
              },
              function () {},
              globalAlertService.handleErrorResponse
            ).$promise;
          }
        ],
        contacts: [
          'contactsResource',
          'globalAlertService',
          '$stateParams',
          '$filter',
          function(contactsResource, globalAlertService, $stateParams, $filter) {
            return contactsResource.assignedContact.get(
              {
                company: $stateParams.company,
                stockNumber: $filter('pathParam')($stateParams.stockNumber),
                division: $stateParams.division,
              },
              function () {},
              globalAlertService.handleErrorResponse
            ).$promise;
          }
        ]
      }
    }
  );
}]);
